import { apiRequest } from "./client";
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
} from "../types/auth";

export function login(request: LoginRequest): Promise<LoginResponse> {
  return apiRequest<LoginResponse>("/auth/login", {
    method: "POST",
    body: JSON.stringify(request),
  });
}

export function register(request: RegisterRequest): Promise<void> {
  if (request.password !== request.repeatPassword) {
    return Promise.reject(
      new Error("Password and repeat password do not match"),
    );
  }

  return apiRequest<void>("/auth/register", {
    method: "POST",
    body: JSON.stringify(request),
  });
}
